import { skipIfNull } from '@proscom/prostore';
import { useRetriableGraphql } from '../../../../common/useRetriableGraphqlVars';
import { QUERY_GET_SECTION_GENERAL_COMMENTS } from '../../../../graphql/queries/infralistComment';

const options = {
  query: QUERY_GET_SECTION_GENERAL_COMMENTS,
  mapData: (result) => result.infralistSectionGeneralCommentaries,
  skipQuery: skipIfNull(null)
};

export function useFetchSectionGeneralComments({ infralistId, sectionId }) {
  const response = useRetriableGraphql({
    queryOptions: options,
    variables: {
      infralist_id: infralistId,
      section_id: sectionId
    },
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    }
  });
  const data = response.state.data;

  return data ?? [];
}
